import { connect } from 'react-redux'
import MemoryStore from '../../utils/memory-store'
import APIKeysForm from '../components/api-keys-form'
import { saveProfile } from '../api-keys-actions'
import { closeTab } from '../../core/core-actions'
import { resetApiKeys, disableApiKey, enableApiKey } from '../api-keys-utils'
import Enums from '../../utils/enums'

const mapStateToProps = state => {
  if (!state[state.core.tabObject.activeApp]) return {}

  const appId = state.core.tabObject.activeApp
  const tabKey = state.core.tabObject.activeKey
  const tabs = state.core.tabObject.tabs
  const entry = MemoryStore.activeEntries[tabKey]
  let title = Enums.VALUES_STRINGS.NEW_PROPER_CASE + Enums.VALUES_STRINGS.SPACE + Enums.APP_PROFILE_TITLES[appId]

  if (entry && !entry.custom.isNewDoc) {
    title = Enums.APP_PROFILE_TITLES[appId] + Enums.VALUES_STRINGS.COLON + Enums.VALUES_STRINGS.SPACE + entry.firstName
  }

  return {
    appId,
    tabKey,
    tabs,
    title,
    state: state[appId],
    theme: state.core.theme
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeTab: (activeKey, targetKey, tabs) => {
      dispatch(closeTab(activeKey, targetKey, tabs))
    },
    saveProfile: (appId, activeKey, state, callback) => {
      dispatch(saveProfile(appId, activeKey, state, callback))
    },
    onResetApiKeys: (id, callback) => {
      resetApiKeys(id, callback)
    },
    onDisableApiKey: (id, callback) => {
      disableApiKey(id, callback)
    },
    onEnableApiKey: (id, callback) => {
      enableApiKey(id, callback)
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(APIKeysForm)
